import { z } from 'zod';

/**
 * The Personal Details form.
 *
 * Only `din` is in the schema, because only `din` is writable: the ASIC feed
 * owns name, email and phone, and there is no endpoint to change them. Putting
 * read-only values in the resolver would mean validating fields the form can
 * never submit.
 *
 * A Director Identification Number is exactly 15 digits, issued by ABRS. It is
 * allowed to be blank — a director who has not yet been issued one must be able
 * to clear a value they typed by mistake.
 */
export const personalDetailsSchema = z.object({
  din: z
    .string()
    .trim()
    .refine((value) => value === '' || /^\d{15}$/.test(value), {
      message: 'A Director ID is 15 digits.',
    }),
});

export type PersonalDetailsInput = z.infer<typeof personalDetailsSchema>;
